import { readDomainCookie, writeDomainCookie } from '@/lib/domain_cookie';

export function getCouponCode(routeQuery: Record<string, any>): string | undefined {
  const routePromo = routeQuery.promo as string | undefined;
  const cookiePromo = readDomainCookie('promo');

  return routePromo || cookiePromo || undefined;
}

export function persistCouponCode(promoCode: string): void {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 1);
  writeDomainCookie('promo', promoCode, { expires: expiryDate });
}

export function buildUpgradeRedirectLink(
  selectedPlan: string,
  careType: string,
  couponCode: string | undefined,
  routeQuery: Record<string, any>
): string {
  const params = new URLSearchParams({
    plan_id: selectedPlan,
    care_type: careType,
  });

  if (couponCode) {
    params.append('promo', couponCode);
  }

  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  utmParams.forEach((param) => {
    const value = routeQuery[param] as string | undefined;
    if (value) {
      params.append(param, value);
    }
  });
  return `/account/seekers/upgrade?${params.toString()}`;
}
